import BasePostMessageHandler from '@common/PostMessageHandler/PostMessageHandler'

const postMessageHandler = new BasePostMessageHandler()

export default postMessageHandler
